import Dictionary from "../../dictionary/dictionary";
import i18n from "../../../../i18n/i18n";
import {PackingModel} from "../../../models/packing";
import {PackingService} from "../../../services/packingService";
import {Api} from "../../../../helpers/api";
import {NavLink} from "react-router-dom";
import Button from "../../../../common/components/shared/button/button";
import {routingAddresses} from "../../../../helpers/routing";
import ReloadButton from "../../../../common/components/shared/reloadButton/reloadButton";
import {SortDirection} from "../../../../common/models/table";
import SearchButton from "../../../../common/components/shared/searchButton/searchButton";
import TextInput from "../../../../common/components/shared/textInput/textInput";

export default class PackingList extends Dictionary<PackingModel> {
    private sortableElements = ["name"];

    constructor(props: any) {
        super(props);

        this.canRemove = true;
        this.linkToModify = routingAddresses.dictionaries.packing.modify;
    }

    public async componentDidMount() {
        this.getData(await this.getAll());
    }

    public render(): JSX.Element {
        const properties = ["name"];
        const headers = properties.map(key => i18n.t("dictionaries.packing.headers." + key));
        const actions = this.renderActions;

        return (
            <div className="packing">
                {this.renderRemovePopup(this.confirmRemove.bind(this))}
                {this.renderWrapperContent(headers, properties, "packing", actions, undefined, this.getHeader(), this.sortableElements, this.sortingAction.bind(this))}
            </div>
        );
    }

    protected async confirmRemove() {
        this.setState({removeItemResponse: undefined, isWaiting: true});

        const response = await PackingService.removePacking(this.state.selectedElement!.id);

        this.setState({removeItemResponse: response});

        if (Api.isSuccess(response)) {
            await this.getData(await this.getAll());
            this.setState({selectedElement: undefined, displayRemovePopup: false});
        } else {
            this.setState({errorMessage: i18n.t("dictionaries.packing.errors.removeErrorSuffix")});
        }
        this.setState({isWaiting: false});
    }

    private getHeader() {
        return (
            <>
                <TextInput
                    className="search-input"
                    label={i18n.t("dictionaries.packing.headers.name")}
                    validatedValue={this.state.selectedValue}
                    testId="filters-name"
                />
                <div className="actions">
                    <SearchButton
                        isWaiting={this.state.isWaiting}
                        onClick={async () => {
                            this.setState({isWaiting: true, dictionaryData: undefined});
                            await this.getData(await this.getAll());
                            this.setState({isWaiting: false});
                        }}
                    />
                    <NavLink to={routingAddresses.dictionaries.packing.add} data-testid="add-pack">
                        <Button type="primary" text={i18n.t("dictionaries.packing.actions.addPacking.button")}/>
                    </NavLink>
                    <ReloadButton
                        reloadFunc={this.reload.bind(this)}
                        testId="packing-list-reload-btn"
                    />
                </div>
            </>
        );
    }

    private async reload() {
        this.reloadList((await this.getAll()));
    }

    private async sortingAction(orderBy: string, sortDirection: SortDirection) {
        await this.setState({orderBy, sortDirection});
        await this.reload();
    }

    private async getAll() {
        return await PackingService.getAll(
            {
                orderBy: this.state.orderBy,
                sortDirection: this.state.sortDirection
            },
            this.state.selectedValue.value.trim()
        );
    }
}
